import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/site";

export const LegalPage = ({ eyebrow, title, updated, sections, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F7F3] text-[#10202E]">
      <header className="sticky top-0 z-40 border-b border-[#10202E]/[0.08] bg-[#F8F7F3]/85 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-6">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-2.5">
            <img src="/assets/logo-mark.png" alt="HRKAPITAL logo" className="h-8 w-8 object-contain" />
            <span className="font-sans text-sm font-semibold tracking-[0.32em]">HRKAPITAL</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-[#4E6A82] transition-colors hover:text-[#10202E]"
          >
            <ArrowLeft className="h-4 w-4" /> Back to site
          </Link>
        </div>
      </header>

      <main data-testid={testId} className="mx-auto max-w-4xl px-6 py-16 md:py-24">
        <span className="inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.32em] text-emerald-600/90">
          <span className="h-px w-8 bg-emerald-500/60" />
          {eyebrow}
        </span>
        <h1 className="mt-5 font-display text-4xl leading-tight tracking-tight sm:text-5xl">{title}</h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#8AA0B0]">
          Last updated — {updated}
        </p>

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-2xl text-[#10202E]">
                <span className="mr-3 font-mono text-xs tracking-[0.2em] text-emerald-600/70">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.heading}
              </h2>
              <div className="mt-3 space-y-3">
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="text-sm font-light leading-relaxed text-[#4E6A82]">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 rounded-2xl border border-[#10202E]/10 bg-white/60 p-6">
          <p className="text-xs leading-relaxed text-[#4E6A82]">
            Questions about this page? Write to us at {BRAND.email} or call {BRAND.phone}.{" "}
            {BRAND.name} · {BRAND.address} · GSTIN {BRAND.gstin} · {BRAND.arn}
          </p>
        </div>
      </main>

      <footer className="border-t border-[#10202E]/[0.08] py-8">
        <p className="text-center font-mono text-[10px] uppercase tracking-[0.25em] text-[#8AA0B0]">
          © 2026 HRKAPITAL · AMFI Registered Mutual Fund Distributor
        </p>
      </footer>
    </div>
  );
};
